// extracted by mini-css-extract-plugin
export default {"popup-wrapper":"Popup_popup-wrapper__QmwIB","open":"Popup_open__7EFJq","popup-inner":"Popup_popup-inner__uBTxt"};